defer('jQuery', () => {
  $(document).ready(function () {
    $('#NavDrawer .collapsible-trigger').on("click", function () {
      if (!$(this).hasClass("is-open")) {
        var color_collection = $(this).data('color');
        $(this).find('.Icon').css("color", color_collection);
      }
      else {
        $(this).find(".Icon").css("color", "#000");
      }

    });

    if ($(window).width() <= 959) {
      $('[id^="Linklist-"]').each(function () {
        $(this).appendTo("#shopify-section-header .drawer__scrollable");
      });

      $(".custom-close-button").click(function () {
        $('[id^="Linklist-"]').each(function () {
          $(this).removeClass("is-open");
        });
        $(".collapsible-trigger").each(function () {
          $(this).removeClass("is-open");
        });
        $("#NavDrawer").removeClass("drawer--is-open");
        $(".drawer__close .drawer__close-button").trigger("click");
      });

      $('.close-menu-drop').click(function () {
        $('[id^="Linklist-"]').each(function () {
          $(this).removeClass("is-open");
        });
        $(".collapsible-trigger").each(function () {
          $(this).removeClass("is-open");
        });
      });
    }

    $('.button-store').click(function () {
      $('.store-currency-menu').toggleClass('disclosure-list--visible');
    });

    if ($(window).width() <= 959) {
      $('.site-nav__link.site-nav__link--icon.small--hide').removeClass('small--hide site-nav__link');
    }

    $(".store-currency-menu-link").click(function (e) {
      e.preventDefault();
      $("#SwitchStorePopup .new_country").text($(this).attr("data-shipping-countries"));
      $("#SwitchStorePopup .modal_continue").attr("href", $(this).attr("data-href"));
    });

    if ($('#SwitchStorePopup').length > 0) {
      var storeModal = new theme.Modals('SwitchStorePopup', 'store-popup', {
        closeOffContentClick: true,
        solid: true
      });
    }
  });
})
